<template lang="pug">
.progress(
  :style="progressBarParentStyle"
)
  .progress-bar(
    role="progressBar"
    :class="progressBarClass"
    :style="progressBarStyle"
  )
</template>

<script>
import percentage from '~/filters/percentage';

export default {
  name: 'AppProgressBar',
  props: {
    tracked: {
      required: true,
    },
    total: {
      required: true,
    },
    success: {
      type: Boolean,
      default: false,
    },
    barColor: {
      type: String,
    },
    barClasses: {
      type: String,
    },
    barBackground: {
      type: String,
    }
  },
  computed: {
    progressBarClass() {
      if (this.barColor) {
        return;
      }

      if (this.barClasses) {
        return this.barClasses;
      }

      if (this.success) {
        return 'progress-bar-success';
      }

      return 'progress-bar-info';
    },
    progressBarStyle() {
      const styles = {
        width: this.progressBarPercentage,
      };

      if (this.barColor) {
        styles.backgroundColor = this.barColor;
      }

      return styles;
    },
    progressBarPercentage() {
      return percentage(this.tracked, this.total);
    },
    progressBarParentStyle() {
      if (!this.barBackground) { return }

      return {
        backgroundColor: this.barBackground,
      };
    },
  },
};
</script>
